import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ProperPageResult } from 'src/app/model/proper-page-result';
import { LoadingService } from 'src/app/services/loading.service';
import { SnackService } from 'src/app/services/snack.service';
import { SignPlacementPrice } from '../../../../../model/sign/sign-placement-price/sign-placement-price';
import { PageableSort } from 'src/app/services/request.service';
import { CollectionHelper } from 'src/app/helpers/collection-helper';
import { StringHelper } from 'src/app/helpers/string-helper';
import { Observable } from 'rxjs';
import {
  _delete,
  _get,
  _post,
  _put,
} from '../../../../../services/base.service';

@Injectable({
  providedIn: 'root',
})
export class SignPlacementPriceControllerRequestService {
  private defaultSort =
    '&sort=signPlacementPriceType,asc&sort=signMeasurements,asc';

  private static BASE_URL = '/signplacementprices';
  private readonly get: <T>(
    path: string,
    deserialize: (response: any) => T
  ) => Observable<T>;
  private readonly post: <T>(
    path: string,
    body: SignPlacementPrice,
    deserialize: (response: any) => T
  ) => Observable<T>;
  private readonly put: <T>(
    path: string,
    body: SignPlacementPrice,
    deserialize: (response: any) => T
  ) => Observable<T>;
  private readonly delete: (path: string) => Observable<void>;

  private readonly deserializePaged = (res) => {
    const result: ProperPageResult<SignPlacementPrice> = new ProperPageResult();
    result.totalItems = res.totalItems;
    result.items = res.items;
    return result;
  };
  private readonly deserialize = (res) => res as SignPlacementPrice;

  constructor(
    http: HttpClient,
    snackService: SnackService,
    loadingService: LoadingService,
    router: Router
  ) {
    const requestServices = {
      http,
      loadingService,
      router,
      snackService,
    };
    this.get = _get(
      SignPlacementPriceControllerRequestService.BASE_URL,
      requestServices
    );
    this.post = _post(
      SignPlacementPriceControllerRequestService.BASE_URL,
      requestServices
    );
    this.put = _put(
      SignPlacementPriceControllerRequestService.BASE_URL,
      requestServices
    );
    this.delete = _delete(
      SignPlacementPriceControllerRequestService.BASE_URL,
      requestServices
    );
  }

  signPlacementPrices(
    filters: string,
    sorts: PageableSort[],
    pageSize: number,
    page: number
  ): Promise<ProperPageResult<SignPlacementPrice>> {
    const filtersParam = StringHelper.isEmpty(filters)
      ? ''
      : `&filters=${filters}`;
    const pageableParam = `page=${page}&size=${pageSize}`;
    const sortParam = this.getSortsParam(sorts);
    const pathParams = `?${pageableParam}${filtersParam}${sortParam}`;

    return this.get(pathParams, this.deserializePaged).toPromise();
  }

  createSignPlacementPrice(
    signPlacementPrice: SignPlacementPrice
  ): Promise<SignPlacementPrice> {
    return this.post('', signPlacementPrice, this.deserialize).toPromise();
  }

  updateSignPlacementPrice(
    signPlacementPrice: SignPlacementPrice
  ): Promise<SignPlacementPrice> {
    return this.put('', signPlacementPrice, this.deserialize).toPromise();
  }

  removeSignPlacementPrice(
    signPlacementPrice: SignPlacementPrice
  ): Promise<void> {
    return this.delete(`/${signPlacementPrice.id}`).toPromise();
  }

  private getSortsParam(sorts: PageableSort[]): string {
    if (!CollectionHelper.isPopulated(sorts)) {
      return this.defaultSort;
    }

    let sortsParam = '';
    sorts.forEach((s) => (sortsParam += `&sort=${s.key},${s.order}`));

    return sortsParam;
  }
}
